import * as React from "react";

import { string } from "yup";

import { AccountType } from "../../api";
import { api } from "../../client";
import { httpStatusMap } from "../../utils";
import AsyncTextField, { AsyncTextFieldProps } from "../atoms/AsyncTextField";
import { i18nErrorCodes } from "../forms/form-utils";

interface ValidateTypeFieldProps extends Partial<AsyncTextFieldProps> {
  onInvalidation: (accountType: AccountType) => void;
  onValidation: (accountType: AccountType) => void;
  accountType: AccountType;
  value: string;
  noValidate: boolean;
  programId: number;
}

const initState = {
  validating: false,
  valid: false,
  touched: false,
  initiated: false,
  error: "",
};

type Props = ValidateTypeFieldProps;

class ValidateTypeField extends React.Component<Props, typeof initState> {
  public state = initState;

  public componentDidUpdate(lastProps) {
    if (lastProps.value && !this.props.value) {
      this.setState(initState);
    }
  }

  public shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps || this.state !== nextState;
  }

  public render() {
    const { error, touched, validating, initiated, valid } = this.state;

    const { value } = this.props;

    const conditionalProps = {
      error: !!error && (touched || initiated),
      helperText: touched || initiated ? error : "",
      eligible: (initiated || (!valid && touched)) && !!value,
    };

    return <AsyncTextField valid={valid} value={value} validating={validating} onBlur={this.handleBlur} onIdle={this.handleIdle} {...conditionalProps} {...this.props} onChange={this.handleChange} />;
  }

  private handleChange = (e) => {
    const { onChange, onInvalidation, accountType } = this.props;

    onInvalidation(accountType);

    if (onChange) onChange(e);
  };

  private handleIdle = () => {
    const { value } = this.props;

    const hasValidEmailFormat = string().email().isValidSync(value);

    if (!hasValidEmailFormat) {
      this.setState({ error: i18nErrorCodes.invalidEmail });
    } else {
      this.setState({ validating: true, error: "" }, this.validateUser);
    }
  };

  private validateUser = () => {
    this.setState({ initiated: true });

    const { value, accountType, noValidate } = this.props;
    const { programId } = this.props;
    if (noValidate) {
      this.setState({ validating: false, valid: true }, this.handleValid);
      return;
    }
    /* 2nd arg here is of type string in the api-spec */
    api
      .checkUser(value, String(accountType), programId)
      .then(() => {
        this.setState({ validating: false, valid: true }, this.handleValid);
      })
      .catch((res) => {
        this.setState(
          {
            validating: false,
            valid: false,
            error: httpStatusMap[res.status],
          },
          this.handleInvalid
        );
      });
  };

  private handleBlur = () => {
    this.setState({ touched: true });
  };

  private handleValid = () => {
    const { accountType } = this.props;

    this.props.onValidation(accountType);
  };

  private handleInvalid = () => {
    const { accountType } = this.props;

    this.props.onInvalidation(accountType);
  };
}

export default ValidateTypeField;



// WEBPACK FOOTER //
// ./src/components/molecules/ValidateTypeField.tsx